<template>
  <vue-modal id="successPaymentWithQRCodeModal"
             classes="vue-modal-container"
             height="auto"
             name="success-payment-with-qr-code-modal"
             scrollable
             width="50%"
             @closed="modalClosed"
             @before-open="beforeOpen">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <h5>{{ trans.subHeader }}</h5>
      <button class="close-modal"
              @click="$modal.hide('success-payment-with-qr-code-modal')">
        <i class="close icon"/>
      </button>
      <div class="qr-container">
        <qrcode-vue v-if="url"
                    :value="url"
                    level="H"
                    size="200"/>
        <div v-else>Hibás link</div>
      </div>
    </div>
    <div class="content">
      <button class="confirm-btn"
              @click="$modal.hide('success-payment-with-qr-code-modal')">
        {{ trans.confirmBtnText }}
      </button>
    </div>
  </vue-modal>
</template>

<script>
import {mapState} from 'vuex'
import QrcodeVue from 'qrcode.vue';

export default {
  components: { QrcodeVue },
  data () {
    return {
      url: null,
      closeWindowWhenModalClosed: false,
    }
  },
  methods: {
    beforeOpen (event) {
      const data = event.params
      this.url = data.url
      this.closeWindowWhenModalClosed = data.closeWindowWhenModalClosed
    },
    modalClosed () {
      this.url = null
      this.closeWindowWhenModalClosed = false
      if (this.closeWindowWhenModalClosed) window.close()
      if (this.$store.getters.isDigitalMode) this.$router.push('digital')
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.successPaymentWithQRCodeModal,
    }),
  },
}
</script>

<style scoped>
.header {
  text-align: center;
}

.qr-container {
  width: 200px;
  margin: auto;
}

.confirm-btn {
  width: 100%;
  height: 50px;
  font-size: 20px;
  padding: 10px;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  background: #f2711c;
  color: white;
}

.confirm-btn:hover {
  background: #f2711ce0;
}
</style>
